import { Button } from "@/components/ui/button"
import { Loader2, Terminal } from "lucide-react"
import React from "react"
import type { PaymentStatus } from "../types"

interface PaymentActionButtonsProps {
  paymentStatus: PaymentStatus
  createPaymentIntentPending: boolean
  isConnectionReady: boolean
  onProcessPayment: () => void
  onRetry: () => void
}

export const PaymentActionButtons: React.FC<PaymentActionButtonsProps> = ({
  paymentStatus,
  createPaymentIntentPending,
  isConnectionReady,
  onProcessPayment,
  onRetry,
}) => {
  // Bouton pour démarrer le paiement (état idle)
  if (paymentStatus === "idle" && !createPaymentIntentPending) {
    return (
      <Button
        onClick={onProcessPayment}
        className="w-full"
        size="lg"
        disabled={createPaymentIntentPending || !isConnectionReady}
      >
        <Terminal className="h-4 w-4 mr-2" />
        {createPaymentIntentPending
          ? "Préparation..."
          : !isConnectionReady
          ? "Initialisation..."
          : "Démarrer le paiement"}
      </Button>
    )
  }

  // Boutons pour réessayer (état failed)
  if (paymentStatus === "failed") {
    return (
      <div className="space-y-2">
        <Button onClick={onRetry} className="w-full" size="lg">
          Réessayer le paiement
        </Button>
        <Button variant="outline" className="w-full" size="sm">
          Changer de mode de paiement
        </Button>
      </div>
    )
  }

  // Bouton d'annulation en cours
  if (paymentStatus === "cancelling") {
    return (
      <Button disabled className="w-full" size="lg">
        <Loader2 className="h-4 w-4 mr-2 animate-spin" />
        Annulation en cours...
      </Button>
    )
  }

  // Pas de boutons pour les autres états
  return null
}
